/**
 * Base css generation and global js logic.
 */

import $ from 'jquery';

// NOTE: Bootstrap critical and utilities CSS are now generated via the bootstrap/base
// webpack entry point and extracted by splitChunks to bootstrap/critical.css and
// bootstrap/utilities.css. They are NOT imported here to avoid bundling into timberland.css.
// See webpack.config.js entry section.

import './_base.scss';

import 'vide/dist/jquery.vide.min';

/**
 * Global Bootstrap JavaScript Components
 * Scrollspy is loaded globally because it's used for scroll tracking
 */
// eslint-disable-next-line no-unused-vars
import Scrollspy from 'bootstrap/js/src/scrollspy';

import iframeResize from '@iframe-resizer/parent';

// Provide legacy global for compatibility
window.iFrameResize = iframeResize;

// Import AOS
// import AOS from 'aos';
// import 'aos/dist/aos.css';

// Add loaded class to body
const bodyLoaded = () => {
  setTimeout(() => {
    if (document.body) {
      document.body.classList.add('page-loaded');
    }
  }, 1000);
};

/**
 * Smooth scroll to hash anchor on page load
 * Only runs if URL contains a hash, otherwise preserves browser's scroll restoration
 *
 * @see https://www.abitgooey.com/2018/08/smooth-scroll-to-section-on-page-load-jquery/
 */
const smoothScrollToHash = () => {
  const offsetScroll = -148;
  const urlHash = window.location.hash;

  // Only scroll if there's a hash in the URL
  if (urlHash && $('#' + urlHash.replace(/[^\w\s]/gi, '')).length) {
    // Scroll to top first (only when hash is present)
    scroll(0, 0);
    // Void some browsers issue
    setTimeout(scroll(0, 0), 1);

    $(function () {
      // Smooth scroll to the anchor id
      $('html, body').animate({
        scrollTop: $('#' + urlHash.replace(/[^\w\s]/gi, '')).offset().top + offsetScroll
      }, 800);
    });
  }
  // If no hash, do nothing - let browser handle scroll restoration
};

/**
 * Add smooth scrolling behavior to anchor links on the same page
 * Excludes tab/nav links that need default behavior
 *
 */
const smoothScrollLinks = () => {
  const offsetScroll = -148;
  const links = [].slice.call(document.querySelectorAll(`a[href*="#"]:not([href="#0"]):not(.tabs__tab-link):not(.nav-tabs .nav-link):not(.nav-pills .nav-link)`));

  if (links !== null) {
    links.forEach(link => {
      link.addEventListener('click', (e) => {
        // Only handle links to the same page
        if (link.pathname === window.location.pathname) {
          const target = link.hash;

          if (target !== "" && $(target).length) {
            // Prevent default anchor click behavior
            e.preventDefault();

            $('html, body').animate({
              scrollTop: $(target).offset().top + offsetScroll
            }, 800, function () {
              if (history.pushState) {
                history.pushState(null, null, target);
              } else {
                window.location.hash = target;
              }
            });
          } else if (target === "") {
            // Empty hash - scroll to top
            e.preventDefault();

            $('html, body').animate({
              scrollTop: $('body').offset().top + offsetScroll
            }, 800, function () {
              if (history.pushState) {
                history.pushState(null, null, target);
              } else {
                window.location.hash = target;
              }
            });
          }
        }
      });
    });
  }
};

// Scrollspy is auto-initialized via data-bs-spy="scroll" attribute
// Just importing it makes it available

// Global function to limit input fields to numbers only
// used in /src/functions/forms/
// @link: https://www.geeksforgeeks.org/how-to-force-input-field-to-enter-numbers-only-using-javascript/
global.onlyNumberKey = evt => {
  // Only ASCII character in that range allowed
  const ASCIICode = (evt.which) ? evt.which : evt.keyCode
  if (ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57)) {
    return false;
  }
  return true;
};

/**
 * iframe-resizer is in use
 * 
 * { @link https://iframe-resizer.com/ }
 */
iframeResize({
  license: 'GPLv3',
  waitForLoad: true,
  checkOrigin: false,
  sizeHeight: true,
  scrolling: false,
  heightCalculationMethod: 'bodyOffset',
}, '.iframe-height-control iframe');

/**
 * Background Videos
 * 
 * { @link https://vodkabears.github.io/vide/ }
 */
const bgVideos = () => {
  const bgVids = [].slice.call(document.querySelectorAll('.jumbotron[data-mp4], .jumbotron[data-webm], .jumbotron[data-ogv], .block-section[data-mp4], .block-section[data-webm], .block-section[data-ogv]'));

  if (bgVids !== null && bgVids.length) {
    bgVids.forEach(vid => {

      if (vid.dataset.mp4 !== undefined && vid.dataset.mp4 !== null) {
        $(vid).vide({
          mp4: vid.dataset.mp4 ? vid.dataset.mp4 : '',
          webm: vid.dataset.webm ? vid.dataset.webm : '',
          ogv: vid.dataset.ogv ? vid.dataset.ogv : '',
          poster: vid.dataset.poster ? vid.dataset.poster : '',
        }, {
          loop: vid.dataset.loop ? vid.dataset.loop : '',
          autoplay: vid.dataset.autoplay ? vid.dataset.autoplay : '',
          muted: vid.dataset.muted ? vid.dataset.muted : '',
          posterType: 'detect',
          resizing: vid.dataset.resizing ? vid.dataset.resizing : '',
          position: vid.dataset.position ? vid.dataset.position : '',
          bgColor: vid.dataset.bgColor ? vid.dataset.bgColor : '',
          className: vid.dataset.videoClasses ? vid.dataset.videoClasses : '',
        });
      }

    });
  }
}

$(document).ready(() => {
  bodyLoaded();
  smoothScrollToHash();
  smoothScrollLinks();
  bgVideos();
});
